import { Badge, Button, Card, Space, Spin, Typography } from "antd"
import moment from "moment";
import React, { useContext } from "react";
import { SimulatorContext } from "store/context";
import { MdOutlineDownloading } from "react-icons/md";

const { Title } = Typography;

const InprogressJobs = ({ inProgressJobs, setFetchJobDetails }) => {
  return inProgressJobs.map((j) => <Badge.Ribbon text="IN PROGRESS" color="orange">
    <Card style={{ marginBottom: '4%' }} title={'Incoming Deployment'} key={j?.executionId}>
      <p>Created {moment(j?.startedAt).fromNow()}</p>
      <p >Deployment ID: {j?.deploymentId}</p>
      <p >Execution ID: {j?.executionId}</p>
      <br />
      <Button onClick={() => setFetchJobDetails(j?.deploymentId)} color="primary" variant="outlined">
        Describe Job Execution
      </Button>
    </Card >
  </Badge.Ribbon>
  )
}

const QueuedJobs = ({ queuedJobs, inProgressJobs, setFetchJobDetails }) => {
  return queuedJobs.map((j, i) => <Badge.Ribbon text="QUEUED">
    <Card style={{ marginBottom: '4%' }} title={'Incoming Deployment'} className='active-execution' key={j?.executionId}>
      <p>Created {moment(j?.startedAt).fromNow()}</p>
      <p>Deployment ID: {j?.deploymentId}</p>
      <p>Execution ID: {j?.executionId}</p>
      {((inProgressJobs.length === 0) && (i === 0)) && <Button onClick={() => setFetchJobDetails(j?.deploymentId)}>
        Describe Job Execution
      </Button>}
    </Card>
  </Badge.Ribbon>
  )
}

const IncomingDeployments = ({ inProgressJobs, queuedJobs, setFetchJobDetails, isPendingJobLoading }) => {
  const { vehicleSimulatorSettings: { serialNo } } = useContext(SimulatorContext);
  return <>
    {(isPendingJobLoading) ?
      <div style={{ textAlign: 'center' }}>
        <Title level={5}>Looking for {serialNo}'s new deployments</Title>
        <Spin indicator={<MdOutlineDownloading />} spinning />
      </div>
      :
      <Space direction="vertical" style={{ width: '100%' }}>
        {(serialNo && (inProgressJobs.length > 0 || queuedJobs.length > 0)) ?
          <Title level={5} style={{ marginBottom: '2%' }}>Job Executions for {serialNo}</Title> :
          <Title level={5} style={{ textAlign: 'center', marginTop: '10%' }}>No Deployment Executions</Title>
        }
        <InprogressJobs inProgressJobs={inProgressJobs} setFetchJobDetails={setFetchJobDetails} />
        <QueuedJobs inProgressJobs={inProgressJobs} queuedJobs={queuedJobs} setFetchJobDetails={setFetchJobDetails} />
      </Space>
    }
  </>
}

export default IncomingDeployments;